export default __webpack_public_path__ + "static/media/logo.c8953eb9.svg";